import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { ArrowLeft, RefreshCw, Users, CheckCircle2, BarChart3, FileText } from "lucide-react";

export default function CommunityStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const res = await publicApi.publicStats();
      setStats(res.data);
    } catch {
      setStats(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return (
    <div className="public-page">
      <header className="public-header">
        <div className="public-header-inner">
          <div className="guide-header-row">
            <div className="public-logo">
              <img src="/aht_round_orange.png" alt="AHT" style={{ height: 36, width: 36, borderRadius: "50%" }} />
              <span className="dash-logo-text">Aylesbury Hindu Temple</span>
            </div>
            <Link to="/" className="guide-back-link">
              <ArrowLeft size={14} /> Back to Generator
            </Link>
          </div>
        </div>
      </header>

      <main className="community-page">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
          <div>
            <h1 style={{ fontSize: "24px", fontWeight: 700, marginBottom: "4px" }}>Community Progress</h1>
            <p style={{ color: "var(--cf-muted)", fontSize: "14px", margin: 0 }}>
              Anonymous overview of community participation. No personal data is shown.
            </p>
          </div>
          <button className="btn-secondary" onClick={fetchStats} disabled={loading}>
            <RefreshCw size={14} className={loading ? "spin" : ""} />
            <span>Refresh</span>
          </button>
        </div>

        {stats ? (
          <>
            <div className="community-grid">
              <div className="join-stat">
                <Users size={24} style={{ color: "var(--cf-green)", marginBottom: "8px" }} />
                <strong>{stats.total_supporters}</strong>
                <span>Total Supporters</span>
              </div>
              <div className="join-stat">
                <CheckCircle2 size={24} style={{ color: "var(--cf-green)", marginBottom: "8px" }} />
                <strong>{stats.completed_supporters}</strong>
                <span>Completed All Sites</span>
              </div>
              <div className="join-stat">
                <BarChart3 size={24} style={{ color: "var(--cf-green)", marginBottom: "8px" }} />
                <strong>{stats.completion_rate}%</strong>
                <span>Completion Rate</span>
              </div>
              <div className="join-stat">
                <FileText size={24} style={{ color: "var(--cf-green)", marginBottom: "8px" }} />
                <strong>{stats.total_submissions}</strong>
                <span>Total Site Responses</span>
              </div>
            </div>

            {stats.total_supporters > 0 && (
              <div style={{
                marginTop: "24px",
                padding: "20px",
                background: "var(--cf-card)",
                border: "1px solid var(--cf-card-border)",
                borderRadius: "8px",
                textAlign: "center",
              }}>
                <p style={{ fontSize: "18px", fontWeight: 600, marginBottom: "8px" }}>
                  Join {stats.total_supporters} supporters who've already responded
                </p>
                <p style={{ color: "var(--cf-muted)", fontSize: "14px", marginBottom: "16px" }}>
                  Every voice strengthens our community's representation
                </p>
                <Link to="/" className="btn-primary gen-btn" style={{ textDecoration: "none" }}>
                  Start My Response
                </Link>
              </div>
            )}

            <div style={{ textAlign: "center", marginTop: "32px", padding: "16px 0", borderTop: "1px solid var(--cf-card-border)", color: "var(--cf-muted)", fontSize: 13 }}>
              <p style={{ margin: 0 }}>
                Coordinated by <strong style={{ color: "var(--cf-orange)" }}>Aylesbury Hindu Temple &amp; Trust</strong> · <a href="https://www.aylesburyhindutemple.org" target="_blank" rel="noopener noreferrer" style={{ color: "var(--cf-orange)" }}>www.aylesburyhindutemple.org</a>
              </p>
              <p style={{ margin: "8px 0 0", fontSize: 11, opacity: 0.7 }}>
                Built by <a href="https://scaleright.ai/" target="_blank" rel="noopener noreferrer" style={{ color: "var(--cf-orange)" }}>ScaleRight.ai</a>
              </p>
            </div>
          </>
        ) : loading ? (
          <div style={{ textAlign: "center", padding: "40px", color: "var(--cf-muted)" }}>
            Loading community stats...
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "40px", color: "var(--cf-muted)" }}>
            Unable to load stats. Please try again.
          </div>
        )}
      </main>
    </div>
  );
}
